export enum ProviderCommunicationPreferencesEnum {
    Email = 'Email',
    TextMessage = 'Text Message',
    InAppNotifications = 'In-App Notifications',
    PauseAllNotifications = 'Pause all notifications',
}

export const PROVIDER_COMM_METHODS = [
    ProviderCommunicationPreferencesEnum.Email,
    ProviderCommunicationPreferencesEnum.TextMessage,
    ProviderCommunicationPreferencesEnum.InAppNotifications,
    ProviderCommunicationPreferencesEnum.PauseAllNotifications
];

export enum CareManagerCommunicationPreferencesEnum {
    Email = 'Email',
    TextMessage = 'Text Message',
    GuidingCareAlert = 'Guiding Care Alert',
    InAppNotifications = 'In-App Notifications',
}

export const CARE_MANAGER_COMM_METHODS = [
    CareManagerCommunicationPreferencesEnum.Email,
    CareManagerCommunicationPreferencesEnum.TextMessage,
    CareManagerCommunicationPreferencesEnum.GuidingCareAlert,
    CareManagerCommunicationPreferencesEnum.InAppNotifications
];